import React from 'react';
import PartnerCarousel from './PartnerCarousel';


const partenaireQuebec = [
  {
    href: "https://www.mfa.gouv.qc.ca/fr/",
    imgSrc: "/images/partenaires/quebec.png",
    alt: "Ministère de la famille",
  },
  {
    href: "http://cmm.qc.ca/",
    imgSrc: "/images/partenaires/b_CMM_couleur2.jpg",
    alt: "Communauté métropolitaine de Montréal",
  },
  {
    href: "http://www.centraide-mtl.org/fr/",
    imgSrc: "/images/partenaires/centraide11.png",
    alt: "Centraide du Grand Montréal",
  },
  {
    href: "https://www.centraide-quebec.com/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/centraide-qccabsl.png",
    alt: "Centraide Québec, Chaudière-Appalaches et Bas-Saint-Laurent",
  },
  {
    href: "https://www.ville.quebec.qc.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/ville-de-quebec.png",
    alt: "Ville de Québec",
  },
  {
    href: "https://www.ville.levis.qc.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/levis.png",
    alt: "Ville de Lévis",
  },
  {
    href: "https://www.desjardins.com/qc/fr/nous-trouver/caisse-desjardins/levis.html",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/1. Logo Desjardins vert.png",
    alt: "Desjardins",
  },
  {
    href: "https://centraidehcnmanicouagan.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/centraide_hcn.png",
    alt: "Centraide Haute-Côte-Nord",
  },
  {
    href: "https://centraideduplessis.org/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/centraide_duplessis.png",
    alt: "Centraide Duplessis",
  },
  {
    href: "https://www.facebook.com/p/Collectif-de-d%C3%A9veloppement-social-de-la-C%C3%B4te-Nord-61575832787485/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/CDS_Cote_nord.png",
    alt: "CDS Côte-Nord",
  },
  {
    href: "https://www.mrcbm.qc.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/mrc-brome-missisquoi.png",
    alt: "MRC Brome-Missisquoi",
  },
  {
    href: "https://www.rdsbm.org",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/RDSBM_Logo_RVB.png",
    alt: "RDSBM",
  },
  /*{
    href: "https://centraide-rcoq.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/centraide_RCOQ.png",
    alt: "Centraide RCOQ",
  },*/
  {
    href: "https://haute-yamaska.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/mrc-haute-yamaska.png",
    alt: "MRC Haute-Yamaska",
  },
  {
    href: "https://www.centraidery.org/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/centraide-richelieu-yamaska.png",
    alt: "Centraide Richelieu-Yamaska",
  },
  {
    href: "https://www.canada.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/canada.png",
    alt: "Canada",
  },
  {
    href: "https://www.unitedway.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/united-way-centraide.png",
    alt: "United Way - Centraide",
  },
  {
    href: "https://www.benevoleenaction.com/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/convergence-action-benevole.png",
    alt: "Convergence Action Bénévole",
  },
  {
    href: "https://andreannelarouche.ca/",
    imgSrc: "https://211quebec-web.s3.ca-central-1.amazonaws.com/partners/logo_bonne_grandeur/Shefford_AndreanneLarouche.png",
    alt: "Shefford - Andréanne Larouche",
  },
];

function HomeFooter() {
  return (
    <footer className="site-footer quebec-footer flexbox">
      <div className="partenaires">
          <div className="h4 partenaires-titre">
            Nos partenaires
          </div>
          <PartnerCarousel partners={partenaireQuebec} />
      </div>
    </footer>
  );
}

export default HomeFooter;
